const passengerShortcodes = {
  ADULT: 'A',
  CHILD: 'C',
  INFANT: 'I',
  PETS_IN_HOLD: 'PH',
  PETS_IN_CABIN: 'PC',
};

export default passengerShortcodes;
